import { IconButton } from 'app/components/BasicButtons/IconButton';
import { Icon } from 'app/components/BasicIcons/FontAwesome';
import { translations } from 'locales/translations';
import { useTranslation } from 'react-i18next';
import './styles.css';
export interface FileSize {
  size: number;
  name: string;
}
export interface Image {
  name: string;
  path: string;
  size: FileSize;
}
export interface ImageListProps {
  data: Image[] | undefined;
  removeImage: (name: string) => void;
}
export const ImageList = (props: ImageListProps) => {
  const { t } = useTranslation();
  const data: Image[] = props.data !== undefined ? props.data : [];
  return (
    <>
      {data.length > 0 ? (
        <div
          style={{
            width: 384,
            maxHeight: 200,
            overflowY: 'auto',
            overflowX: 'clip',
            borderStyle: 'solid',
            borderWidth: '1px',
            borderColor: 'gray',
          }}
        >
          {data.map(value => (
            <>
              <div
                className={'hiddenImgTxt'}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <IconButton
                  variant="ghost"
                  aria-label="close"
                  title={t(translations.RemoveImage)}
                  onClick={() => {
                    props.removeImage(value.name);
                  }}
                  size="small"
                >
                  <Icon icon="times" />
                </IconButton>
                {value.name +
                  ' - ' +
                  value.size.size.toString() +
                  ' ' +
                  value.size.name}
              </div>
              <div className={'hiddenimg'}>
                <img
                  src={value.path}
                  alt={value.path}
                  style={{ maxWidth: '50px', maxHeight: '50px' }}
                />
              </div>
            </>
          ))}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
